import produce from "immer";
import DragLayerComponent from "./drag";
import DesignComponent from "./design";
import RuntimeComponent from "./runtime";
import {
  ComponentType,
  TextStyleProps,
  BorderStypeType,
  DefaultComponentProperty,
} from "common/components/types";

const CheckBox: ComponentType = {
  DragLayerComponent: DragLayerComponent,
  DesignComponent: DesignComponent,
  RuntimeComponent: RuntimeComponent,
  property: produce(DefaultComponentProperty, (draft) => {
    draft.name = "MSG_CREATOR_COMPONENT_NAME_CHECKBOX";
    draft.defaultName = "MSG_CREATOR_COMPONENT_NAME_CHECKBOX";
    draft.text = "MSG_CREATOR_COMPONENT_NAME_CHECKBOX";
    draft.defaultText = "MSG_CREATOR_COMPONENT_NAME_CHECKBOX";

    const initalWidth = 140;
    const initalHeight = 16;

    draft.style.defaultLayout.width = initalWidth;
    draft.style.defaultLayout.height = initalHeight;
    draft.style.defaultText = TextStyleProps;
    draft.style.defaultView.borderStyle = BorderStypeType.NONE;

    draft.style.layout.width = initalWidth;
    draft.style.layout.height = initalHeight;
    draft.style.text = TextStyleProps;
    draft.style.view.borderStyle = BorderStypeType.NONE;

    draft.events = ["checkbox_value_change_event"];
  }),
};

export default CheckBox;
